export default "__VITE_ASSET__3d07de13__"